import React from 'react';
import { connect } from "react-redux";
import Button from "components/button";
import { BUTTON_ICONS } from "../../../variables/constants";
import { toggleSideMenu } from '../../../redux/layout/layoutState';

function ToggleCollapse({className, doToggleSideMenu, isCollapse, ...rest}) {
	
    const Icon = isCollapse ? BUTTON_ICONS['MenuExpand'] : BUTTON_ICONS['MenuCollapse'];

    const onToggleCollapse = () => {
        doToggleSideMenu(!isCollapse);
    }

    return (<>
    	<Button className="w-12 h-12 p-0 flex items-center justify-center bg-white/10"
    		{...rest}
            onClick={onToggleCollapse}
		>
  			{Icon && <Icon className='w-6 h-6 dark:text-white'/>}
		</Button> 
    </>);
}

const mapStateToProps = (state) => ({
	isCollapse: state.layout.isSideMenuCollapse,
});

const mapDispatchToProps = (dispatch) => ({
	doToggleSideMenu: (value) => dispatch(toggleSideMenu(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ToggleCollapse);

